export const STYLE_SHEET_VAR = {
    bottomSheet: "--bottom-sheet-height",
    cartFooter: "--cart-footer-height",
};

export const DEFAULT_HEIGHT = 0;

export const setElementHeightInDom = (height: number, name: string): void => {
    document.documentElement.style.setProperty(name, `${height}px`);
};
export const resetElementHeightInDom = (elementName: string, resetHeight = DEFAULT_HEIGHT): void => {
    document.documentElement.style.setProperty(elementName, `${resetHeight}px`);
};
